// React
import React, { useEffect, useState } from 'react';

// Containers Injections
import { DashboardInjection } from '../../containers/dashboardInjection';

// View
import { DashboardPage } from './view';

// Helpers
import { APIClient, getLoggedinUser } from '../../../../helpers/api_helper';

export const Dashboard = () => {
  const user = getLoggedinUser();
  let offices = getLoggedinUser().data.offices;
  let hasSingleOffice = Boolean(offices.length === 1);

  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filterOffice, setFilterOffice] = useState(
    hasSingleOffice && {
      label: offices[0].name,
      value: offices[0].office_id,
    }
  );

  const api = new APIClient();
  const { markers, getOverviewMapsData } = DashboardInjection();

  const getOverview = async (office) => {
    await api.get(`/overview?office=${office}`).then((res) => {
      setMetrics(res);
      setLoading(false);
    });
  };

  useEffect(() => {
    getOverview(filterOffice.value || '');
    getOverviewMapsData(filterOffice.value || '');
  }, [filterOffice]);

  return (
    <DashboardPage
      loading={loading}
      markers={markers || []}
      offices={offices || []}
      user={user.data || null}
      metrics={metrics || null}
      filterOffice={filterOffice}
      setFilterOffice={setFilterOffice}
      isShowResume={metrics?.showMetrics?.resume}
      isShowDemo={metrics?.showMetrics?.demographic}
      isShowFinances={metrics?.showMetrics?.finances}
      isShowByPlan={metrics?.showMetrics?.proposalPlans}
      isShowMap={metrics?.showMetrics?.customerByCities}
      isShowProposal={metrics?.showMetrics?.proposalChart}
      isShowForecast={metrics?.showMetrics?.salesForecast}
      isShowPreProposals={metrics?.showMetrics?.preProposals}
      isShowBySituation={metrics?.showMetrics?.proposalBySituation}
    />
  );
};
